(() => {
  const initialise = (carousel) => {
    if (carousel.dataset.reviewCarouselReady === 'true') return;
    carousel.dataset.reviewCarouselReady = 'true';
    const track = carousel.querySelector('[data-review-track]');
    const cards = [...carousel.querySelectorAll('[data-review-card]')];
    const previous = carousel.querySelector('[data-review-previous]');
    const next = carousel.querySelector('[data-review-next]');
    if (!track || cards.length < 2 || !previous || !next) return;
    let page = 0;
    const pageCount = () => Math.ceil(cards.length / 3);
    const update = () => {
      if (window.matchMedia('(max-width: 749px)').matches) {
        track.style.transform = '';
        return;
      }
      const target = cards[Math.min(page * 3, cards.length - 1)];
      track.style.transform = `translateX(-${target.offsetLeft}px)`;
    };
    previous.addEventListener('click', () => {
      page = (page - 1 + pageCount()) % pageCount();
      update();
    });
    next.addEventListener('click', () => {
      page = (page + 1) % pageCount();
      update();
    });
    window.addEventListener('resize', update, { passive: true });
  };
  const initialiseAll = () => document.querySelectorAll('[data-h2l-review-carousel]').forEach(initialise);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialiseAll);
  else initialiseAll();
  document.addEventListener('shopify:section:load', initialiseAll);
})();
